<template>
  <div v-if="validationErrors.length" class="validation-errors">
    <ul v-for="error in validationErrors">
      <li class="invalid-feedback"> {{ error }} </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    validationErrors: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.validation-errors {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    text-align: left;

    .invalid-feedback {
      display: inline;
      margin: 0;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/validation-errors.vue